import {FITH2GameAssets} from "../FITH2GameAssets";
import {BitmapTextStyleOptions} from "../components/BasicBitmapCountUp";

export class FITH2FontConfig {
    public static WAYS:BitmapTextStyleOptions = {
        fontName : FITH2GameAssets.BITMAP_FONT_WAYS,
        fontSize : 24
    }

    public static FREESPINS_LEFT:BitmapTextStyleOptions = {
        fontName : FITH2GameAssets.BITMAP_FONT_WAYS,
        fontSize : 36
    }

    public static FS_COIN_MULTI:BitmapTextStyleOptions = {
        fontName : FITH2GameAssets.BITMAP_FONT_FS_COIN_MULTI,
        fontSize : 24
    }

    public static FS_COIN_MULTI_FLY:BitmapTextStyleOptions = {
        fontName : FITH2GameAssets.BITMAP_FONT_FS_COIN_MULTI,
        fontSize : 24
    }

    public static MULTIPLIER_SYMBOL_STYLE:BitmapTextStyleOptions = {
        fontName : FITH2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 12
    }

    public static MULTIPLIER_GAME_STYLE:BitmapTextStyleOptions = {
        fontName : FITH2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 16
    }

    public static REEL_MULTIPLIER_VALUE:BitmapTextStyleOptions = {
        fontName : FITH2GameAssets.BITMAP_FONT_REEL_MULTI,
        fontSize : 16
    }
}